import { createContext, useContext, useEffect, useState } from "react";

const LS_KEY = "bedtime_settings_v2";

const defaultSettings = {
  story: {
    provider: "groq",
    model: "",
    apiKey: "",
  },
  voice: {
    provider: "webspeech", // webspeech | elevenlabs | openai
    elevenlabsApiKey: "",
    elevenlabsVoiceId: "21m00Tcm4TlvDq8ikWAM",
    elevenlabsModel: "eleven_multilingual_v2",
    openaiApiKey: "",
    openaiVoice: "nova",
    openaiModel: "tts-1",
    webSpeechRate: 0.92,
    webSpeechPitch: 1.0,
  },
};

const SettingsContext = createContext({
  settings: defaultSettings,
  setSettings: () => {},
  resetSettings: () => {},
});

export function SettingsProvider({ children }) {
  const [settings, setSettingsState] = useState(defaultSettings);

  useEffect(() => {
    try {
      const raw = localStorage.getItem(LS_KEY);
      if (raw) {
        const parsed = JSON.parse(raw);
        setSettingsState({
          story: { ...defaultSettings.story, ...(parsed.story || {}) },
          voice: { ...defaultSettings.voice, ...(parsed.voice || {}) },
        });
      }
    } catch {
      // ignore
    }
  }, []);

  const setSettings = (updater) => {
    setSettingsState((prev) => {
      const next = typeof updater === "function" ? updater(prev) : updater;
      try {
        localStorage.setItem(LS_KEY, JSON.stringify(next));
      } catch {
        // ignore
      }
      return next;
    });
  };

  const resetSettings = () => {
    setSettings(defaultSettings);
  };

  return (
    <SettingsContext.Provider value={{ settings, setSettings, resetSettings }}>
      {children}
    </SettingsContext.Provider>
  );
}

export function useSettings() {
  return useContext(SettingsContext);
}

export { defaultSettings };
